// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tab":"tab_nPZEi","active":"active_O0O56"};